// Google Ads — xizmat sahifasi kontenti (Innobek)

const uz = {
    meta: {
        title: "Google Ads — kontekst reklama sozlash va boshqarish",
        description:
            "Google Ads kontekst reklamasi: kampaniya sozlash, konversiya kuzatuvi, haftalik optimizatsiya. Birinchi arizalar bir necha kunda. Boshqaruv oyiga 4 000 000 so'mdan.",
        keywords: [
            "Google Ads",
            "kontekst reklama",
            "Google reklama sozlash",
            "Google Ads narxi",
            "bosish narxi CPC",
            "reklama byudjeti",
            "remarketing",
            "lid narxi",
            "Toshkentda kontekst reklama",
        ],
    },
    hero: {
        eyebrow: "Google Ads / Kontekst reklama",
        h1: "Google Ads — birinchi ariza shu haftada",
        lead:
            "SEO oylab kutishni talab qiladi. Google Ads esa ishga tushgan kunidan trafik beradi. Biz e'lonni aynan sizni qidirayotgan odamga ko'rsatamiz, har bir so'mning qayerga ketganini ko'rsatib beramiz va byudjetni natija chiqayotgan kampaniyaga yo'naltiramiz.",
        ctaPrimary: "Bepul hisob-kitob olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Byudjet sizning akkauntingizda qoladi",
            "Har bir arizaning narxi raqamda ko'rinadi",
            "E'lonlar o'zbek va rus tilida",
            "Haftalik optimizatsiya, oylik hisobot",
        ],
    },
    intro: {
        h: "Google Ads nima va u qanday ishlaydi",
        p: [
            "Google Ads — foydalanuvchi biror narsani qidirganda, aynan shu so'rovga mos e'lonni qidiruv natijalari tepasida ko'rsatish tizimi. Odam «Toshkentda konditsioner o'rnatish narxi» deb yozadi va birinchi qatorda sizning e'loningizni ko'radi. Ya'ni siz e'tiborni sotib olmayapsiz — allaqachon shakllangan ehtiyojga javob berayapsiz.",
            "To'lov bosish uchun olinadi, ko'rsatish uchun emas. Bu — kontekst reklamaning asosiy kuchi: e'lon ming marta ko'rinsa ham, bosilmaguncha pul yechilmaydi. Bosish narxi (CPC) auksion orqali aniqlanadi: sizning stavkangiz va e'lonning sifat ko'rsatkichi birga hisoblanadi. Sifat ko'rsatkichi yuqori bo'lsa, raqobatchidan arzonroq stavka bilan ham yuqoriroq turasiz.",
            "O'zbekiston bozorida bosish narxi soha bo'yicha keskin farq qiladi. Oddiy tijorat so'rovlarida CPC odatda 600–2 500 so'm oralig'ida. Raqobati yuqori yo'nalishlarda — tibbiyot, yuridik xizmat, ko'chmas mulk, qurilish materiallari — 3 000–10 000 so'mgacha chiqadi. Aniq raqamni faqat sohangiz bo'yicha so'rovlarni tekshirgandan keyin aytish mumkin, shuning uchun hisob-kitobni biz bepul qilamiz.",
            "Google Ads'ning zaif tomonini ham ayting deb so'rasangiz — u to'xtaganda trafik ham to'xtaydi. SEO'da qilingan ish saytda qoladi, reklamada esa byudjet tugagan kuni ariza oqimi nolga tushadi. Shuning uchun ko'p mijozimiz reklamadan boshlab, parallel ravishda SEO olib boradi va oltinchi oydan keyin reklama byudjetini asta kamaytiradi.",
            "Yana bir muhim gap: reklama yomon saytni qutqarmaydi. Agar qo'nish sahifasi sekin ochilsa, telefon raqami ko'rinmasa yoki mobil versiyada forma ishlamasa, siz bosish uchun to'laysiz-u, ariza olmaysiz. Shuning uchun biz kampaniyani ishga tushirishdan oldin sahifani tekshiramiz va muammolarni ochiq aytamiz.",
            "O'zbekiston bozorida yana bir xususiyat bor: e'lonlar ikki tilda yozilishi kerak. O'zbekcha so'rovlar bo'yicha raqobat ko'pincha pastroq, ya'ni bosish arzonroq tushadi, lekin ko'p kompaniya bu qismni umuman e'tibordan chetda qoldiradi. Biz har bir e'lon guruhi uchun ikkala tilda matn tayyorlaymiz va qaysi biri arzonroq ariza berayotganini hisobotda ko'rsatamiz.",
        ],
    },
    definition: {
        term: "Kontekst reklama nima?",
        text:
            "Kontekst reklama — foydalanuvchining qidiruv so'roviga yoki qiziqishlariga mos e'lonni ko'rsatib, faqat bosish uchun to'lanadigan reklama turi. Google Ads — bu turdagi reklamaning eng yirik platformasi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Google Ads xizmatiga nimalar kiradi",
        sub: "Ro'yxatdan sizga keraklilari tanlanadi — reja hisob-kitobdan keyin tuziladi.",
        items: [
            "Kalit so'zlar va raqobat tahlili, taxminiy CPC hisobi",
            "Google Ads akkauntini noldan sozlash yoki mavjudini audit qilish",
            "Qidiruv kampaniyalari va e'lon guruhlarini qurish",
            "E'lon matnlari o'zbek va rus tilida, har biriga 3–4 variant",
            "Salbiy so'zlar ro'yxati — behuda bosishlarni kesish",
            "Google Analytics 4 va konversiya kuzatuvini ulash",
            "Qo'nish sahifasini baholash va aniq tuzatish tavsiyalari",
            "Remarketing: saytga kirgan, lekin ariza qoldirmaganlarni qaytarish",
            "Performance Max va Shopping kampaniyalari (internet-do'konlar uchun)",
            "YouTube va Display tarmog'ida ko'rsatish (kerak bo'lsa)",
            "Haftalik optimizatsiya: stavkalar, so'rovlar, e'lonlar, byudjet taqsimoti",
            "A/B testlar: sarlavha, matn, kengaytmalar, qo'nish sahifasi",
            "Oylik hisobot: ariza soni, bitta ariza narxi, dinamika",
            "Chaqiruvlarni kuzatish (call tracking) sozlash",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Google Ads nima beradi",
        sub: "Uning kuchi ikkita narsada: tezlik va o'lchanuvchanlik.",
        items: [
            {
                t: "Natija bir necha kunda",
                d: "Kampaniya ishga tushgan kuni birinchi tashriflar keladi. Yangi mahsulotni yoki aksiyani tez sinab ko'rish uchun eng qulay kanal.",
            },
            {
                t: "Har bir so'm ko'rinadi",
                d: "Qaysi so'rov necha ariza keltirgani va bitta ariza qanchaga tushgani jadvalda. Bu — marketingdagi eng shaffof kanal.",
            },
            {
                t: "Faqat qiziqqanlarga ko'rsatiladi",
                d: "E'lon aynan sizning mahsulotingizni qidirayotgan odamga chiqadi. Banner yoki televizor reklamasidan farqi shu — behuda auditoriya yo'q.",
            },
            {
                t: "Byudjet to'liq nazoratda",
                d: "Kunlik chegara, hudud, vaqt oralig'i, qurilma turi bo'yicha cheklov qo'yasiz. Istalgan payt to'xtatish yoki oshirish mumkin.",
            },
            {
                t: "Ketganlarni qaytarish",
                d: "Saytga kirib, ariza qoldirmagan odamga remarketing orqali qayta murojaat qilinadi. Bu odatda eng arzon ariza manbai bo'lib chiqadi.",
            },
            {
                t: "SEO uchun tayyor ma'lumot",
                d: "Reklama bir-ikki oyda qaysi so'rovlar haqiqatda pul keltirishini aniq ko'rsatadi. Bu ma'lumot keyingi SEO rejasini ancha aniqroq qiladi.",
            },
            {
                t: "Mavsumga tez moslashish",
                d: "Talab ko'tarilgan haftada byudjetni oshirasiz, tushganda kamaytirasiz. Yangi filial ochilsa, o'sha hudud bir kunda qo'shiladi. SEO'da bunday tezkor manevr qilib bo'lmaydi.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlarga mos",
        h: "Google Ads kimlar uchun samarali",
        sub: "Mahsuloti qidiriladigan va bitta mijoz qiymati reklama xarajatini oqlaydigan bizneslar uchun.",
        items: [
            {
                t: "Tez ariza kerak bo'lganlar",
                d: "Yangi ochilgan biznes yoki sotuv rejasi qisilgan holat. SEO natijasini kutishga oy yo'q.",
            },
            {
                t: "Mavsumiy bizneslar",
                d: "Konditsioner, isitish tizimi, bayram xizmatlari. Talab ko'tarilgan haftalarda tez ko'rinish hal qiluvchi.",
            },
            {
                t: "Xizmat ko'rsatuvchilar",
                d: "Klinika, yurist, ta'mirlash, klining. Bitta mijozning qiymati yuqori, shuning uchun reklama tez o'zini oqlaydi.",
            },
            {
                t: "Internet-do'konlar",
                d: "Mahsulot kartochkalari uchun Shopping va Performance Max kampaniyalari. Katalog to'g'ri ulansa, natija barqaror.",
            },
            {
                t: "Yangi mahsulotni sinovchilar",
                d: "G'oya bozorda ishlaydimi — buni ikki haftalik reklama testi aniq ko'rsatadi, katta byudjet sarflamasdan va omborni to'ldirmasdan oldin.",
            },
            {
                t: "SEO'ni endi boshlaganlar",
                d: "SEO natija bergunicha reklama trafikni ushlab turadi. Keyinchalik reklama byudjeti bosqichma-bosqich kamaytiriladi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Google Ads xizmati narxlari",
        sub: "Xizmat haqi va reklama byudjeti — bu ikki alohida summa. Byudjet to'g'ridan-to'g'ri Google'ga to'lanadi.",
        note:
            "Muhim: reklama byudjeti sizning o'z akkauntingizdan to'lanadi va bizga o'tmaydi — har bir so'mni o'zingiz ko'rib turasiz. Biz faqat sozlash va boshqarish xizmati uchun haq olamiz. Agentlik komissiyasi bozorda odatda byudjetning 10–20 foizi; bizda 15 foiz yoki quyidagi qat'iy summa — qaysi biri katta bo'lsa. Minimal tavsiya etiladigan reklama byudjeti — oyiga 8 000 000 so'm; bundan kami bilan ma'lumot to'planmaydi va optimizatsiya qilib bo'lmaydi. Savollar bo'lsa: +998 90 954 12 62.",
        tiers: [
            {
                name: "Ishga tushirish",
                tagline: "Bir martalik sozlash",
                price: "4 500 000 so'm",
                priceNote: "bir martalik",
                term: "7–10 ish kuni",
                best: "Akkauntni to'g'ri sozlab, keyin o'z marketologingiz bilan yuritmoqchi bo'lganlar uchun",
                features: [
                    "Kalit so'zlar va raqobat tahlili, CPC prognozi",
                    "Google Ads akkauntini noldan qurish",
                    "2–3 ta qidiruv kampaniyasi va e'lon guruhlari",
                    "E'lon matnlari o'zbek va rus tilida",
                    "Salbiy so'zlar bazaviy ro'yxati",
                    "GA4 va konversiya kuzatuvini ulash",
                    "Qo'nish sahifasi bo'yicha tavsiyalar ro'yxati",
                    "Akkauntni boshqarish bo'yicha 2 soatlik o'qitish",
                ],
            },
            {
                name: "Boshqaruv",
                tagline: "Doimiy yuritish va optimizatsiya",
                price: "4 000 000 so'm",
                priceNote: "oyiga yoki byudjetning 15% — qaysi biri katta",
                term: "Oylik abonent to'lov",
                best: "Reklamadan barqaror va bashorat qilinadigan ariza oqimini xohlaydiganlar uchun",
                featured: true,
                features: [
                    "Ishga tushirish paketidagi barcha ishlar birinchi oyda",
                    "Haftalik optimizatsiya: stavkalar, so'rovlar, e'lonlar",
                    "Samarasiz so'rovlarni o'chirish va byudjetni qayta taqsimlash",
                    "Remarketing kampaniyalari",
                    "E'lon va kengaytmalarni muntazam yangilash",
                    "A/B testlar: sarlavha, matn, qo'nish sahifasi",
                    "Chaqiruvlarni kuzatish sozlash",
                    "Oylik hisobot: ariza soni, narxi va dinamikasi",
                    "Har oy natijalar bo'yicha uchrashuv",
                ],
            },
            {
                name: "Kompleks",
                tagline: "Reklama + qo'nish sahifasi + analitika",
                price: "8 000 000 so'm",
                priceNote: "oyiga yoki byudjetning 12% — qaysi biri katta",
                term: "Oylik abonent to'lov",
                best: "Katta byudjet, bir nechta yo'nalish yoki keng katalog bilan ishlaydiganlar uchun",
                features: [
                    "Boshqaruv paketidagi barcha ishlar",
                    "Kampaniyalar uchun alohida qo'nish sahifalari",
                    "Shopping va Performance Max kampaniyalari",
                    "CRM bilan bog'lash: ariza bitimga aylandimi",
                    "Chuqur analitika: qaysi kanal qanday mijoz keltiryapti",
                    "Bir nechta hudud, til va mahsulot yo'nalishi",
                    "YouTube va Display kampaniyalari",
                    "Shaxsiy menejer va haftalik aloqa",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Reklama qanday ishga tushiriladi",
        sub: "Birinchi arizalar odatda ishga tushirilgandan keyin 3–10 kun ichida keladi.",
        steps: [
            {
                t: "Tahlil va hisob-kitob",
                time: "2–4 kun",
                d: "Sohangiz, raqobatchilar va so'rovlar tekshiriladi. Taxminiy bosish narxi, kutilayotgan ariza soni va kerakli byudjet hisoblanadi — bepul.",
            },
            {
                t: "Kuzatuvni sozlash",
                time: "2–3 kun",
                d: "GA4, konversiya maqsadlari va chaqiruv kuzatuvi ulanadi. Bu bosqichsiz reklama ko'r ishlaydi: qaysi so'rov pul keltirgani ko'rinmaydi.",
            },
            {
                t: "Kampaniyalarni qurish",
                time: "3–7 kun",
                d: "Kalit so'zlar guruhlanadi, e'lon matnlari ikki tilda yoziladi, salbiy so'zlar kiritiladi, hudud va vaqt jadvali sozlanadi.",
            },
            {
                t: "Byudjetni taqsimlash",
                time: "1 kun",
                d: "Odatdagi sxema: 60–70% issiq tijorat so'rovlariga, 15–20% remarketingga, 10–20% yangi gipotezalarni sinash uchun.",
            },
            {
                t: "Ishga tushirish",
                time: "1 kun",
                d: "Kampaniyalar yoqiladi. Birinchi hafta kuzatuv zichroq bo'ladi — keraksiz so'rovlar kunlik tekshiruv bilan darhol kesiladi.",
            },
            {
                t: "Optimizatsiya",
                time: "har hafta",
                d: "Qaysi so'rov ariza berdi, qaysi biri faqat pul yedi — shu asosda stavkalar o'zgaradi, byudjet ishlayotgan tomonga suriladi.",
            },
            {
                t: "Hisobot va reja",
                time: "har oy",
                d: "Ariza soni, bitta ariza narxi va bitimga aylanish ulushi ko'rsatiladi. Keyingi oy rejasi shu raqamlar asosida tuziladi.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Reklama trafigi uchun qurilgan saytlar",
        sub: "Quyidagi loyihalar konversiya va reklama oqimi hisobga olingan holda ishlab chiqilgan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["mountain-and-sea", "cleanza", "global-building-group", "ipsum-pathology"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Google Ads bo'yicha ko'p beriladigan savollar",
        sub: "Byudjet, narx va natija haqida ochiq javoblar.",
        items: [
            {
                q: "Google Ads xizmati qancha turadi?",
                a: "Innobek'da bir martalik sozlash 4 500 000 so'm. Doimiy boshqaruv oyiga 4 000 000 so'm yoki reklama byudjetining 15 foizi — qaysi biri katta bo'lsa. Kompleks paket 8 000 000 so'm yoki byudjetning 12 foizi. Bu summalar reklama byudjetidan alohida: byudjet to'g'ridan-to'g'ri Google'ga to'lanadi.",
            },
            {
                q: "Reklama byudjeti qancha bo'lishi kerak?",
                a: "Minimal tavsiya — oyiga 8 000 000 so'm. Bundan kami bilan algoritm o'rganish uchun yetarli ma'lumot to'plamaydi va optimizatsiya samarasiz bo'ladi. Raqobati yuqori sohalarda boshlang'ich byudjet 15–25 million so'mdan boshlanadi. Aniq raqam sohangiz CPC'si va kerakli ariza soniga qarab hisoblanadi.",
            },
            {
                q: "Byudjet qanday taqsimlanadi?",
                a: "Odatdagi sxema: 60–70 foizi issiq tijorat so'rovlariga («narxi», «sotib olish», «buyurtma»), 15–20 foizi remarketingga, qolgan 10–20 foizi yangi so'rovlar va gipotezalarni sinashga. Birinchi oyda test ulushi kattaroq bo'ladi, keyin ma'lumot to'plangach byudjet ishlayotgan kampaniyalar foydasiga qayta taqsimlanadi. Har oylik hisobotda taqsimot qanday o'zgargani va nima uchun o'zgargani alohida ko'rsatiladi.",
            },
            {
                q: "Agentlik komissiyasi qancha?",
                a: "O'zbekiston bozorida agentliklar odatda reklama byudjetining 10–20 foizini oladi. Innobek'da komissiya 15 foiz yoki qat'iy 4 000 000 so'm — qaysi biri katta bo'lsa. Katta byudjetlar uchun kompleks paketda foiz 12 gacha tushadi. Yashirin qo'shimcha to'lovlar yo'q, byudjetga ustama qo'yilmaydi.",
            },
            {
                q: "O'zbekistonda bitta bosish qancha turadi?",
                a: "Oddiy tijorat so'rovlarida CPC odatda 600–2 500 so'm oralig'ida. Raqobati yuqori sohalarda — tibbiyot, yuridik xizmat, ko'chmas mulk, qurilish — 3 000 dan 10 000 so'mgacha chiqishi mumkin. Aniq raqam auksion, stavkalar va e'lon sifat ko'rsatkichiga bog'liq. Hisob-kitobda sohangiz bo'yicha real oraliq beriladi.",
            },
            {
                q: "Bitta ariza qanchaga tushadi?",
                a: "Bu CPC va sahifaning konversiyasiga bog'liq. Masalan, bosish 1 500 so'm, konversiya 4 foiz bo'lsa, bitta ariza taxminan 37 500 so'mga tushadi. Konversiyani 6 foizga ko'tarish ariza narxini 25 000 so'mga tushiradi — shuning uchun biz qo'nish sahifasi bilan ham ishlaymiz.",
            },
            {
                q: "Natija qancha vaqtda ko'rinadi?",
                a: "Birinchi tashriflar kampaniya yoqilgan kuniyoq keladi, birinchi arizalar esa odatda 3–10 kun ichida tushadi. Lekin dastlabki 2–4 hafta — bu o'rganish davri: algoritm ma'lumot to'playdi, biz keraksiz so'rovlarni kesamiz va stavkalarni sozlaymiz. Barqaror hamda bashorat qilinadigan natija ikkinchi oydan boshlab shakllanadi. Birinchi oy raqamlarini yakuniy deb baholamang.",
            },
            {
                q: "Byudjet sizga o'tadimi?",
                a: "Yo'q. Akkaunt sizning kompaniyangiz nomiga ochiladi va to'lov kartasi ham sizniki bo'ladi. Google pulni to'g'ridan-to'g'ri sizdan yechadi, biz esa faqat boshqaruv huquqiga ega bo'lamiz. Shu sababli har bir so'mning qayerga ketganini istalgan payt o'zingiz tekshira olasiz. Shartnoma tugasa, akkaunt butun tarixi bilan sizda qoladi.",
            },
            {
                q: "Mening saytim yo'q, faqat Instagram bor — bo'ladimi?",
                a: "Google Ads uchun qo'nish sahifasi kerak. Instagram sahifasiga reklama yuborish mumkin, lekin konversiya sezilarli past chiqadi va kuzatuv to'liq ishlamaydi. Eng arzon yechim — bitta landing page qurish. Buni biz alohida xizmat sifatida qilamiz va reklama bilan birga ishga tushiramiz.",
            },
            {
                q: "Reklamani o'zim yuritsam bo'ladimi?",
                a: "Ha, bo'ladi. Ishga tushirish paketida biz akkauntni to'g'ri quramiz, sozlamalarni tushuntiramiz va jamoangizni o'qitamiz. Lekin hisobga oling: Google interfeysi doimo avtomatik kampaniyalarni taklif qiladi va tajribasiz qo'lda byudjet juda tez yeyiladi. Birinchi 2–3 oy boshqaruvni bizga qoldirib, natija barqarorlashgach o'zingizga o'tkazib olish ko'proq mantiqiy.",
            },
            {
                q: "SEO bilan Google Ads'ni birga qilish kerakmi?",
                a: "Agar byudjet yetsa — ha, bu eng samarali kombinatsiya. Reklama bugundan ariza beradi va qaysi so'rovlar pul keltirishini tez ko'rsatadi. SEO shu ma'lumot asosida aniqroq quriladi va oltinchi oydan keyin ariza tannarxini tushiradi. Vaqt o'tib reklama byudjetini kamaytirish mumkin bo'ladi.",
            },
        ],
    },
    cta: {
        h: "Sohangizda reklama qanchaga tushishini bilmoqchimisiz?",
        p: "Bepul hisob-kitobda so'rovlar hajmini, taxminiy bosish narxini va kerakli byudjetni ko'rsatamiz. Agar raqamlar sizga mos kelmasa — buni ham to'g'ridan-to'g'ri aytamiz.",
        button: "Bepul hisob-kitob olish",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/services/google-ads-kampaniya.webp",
            alt: "Google Ads kampaniyalari paneli: bosishlar, konversiyalar va ariza narxi",
            caption: "Boshqaruv panelida har bir kampaniyaning ariza soni va narxi ko'rinib turadi.",
            prompt:
                "Clean Google Ads style campaign dashboard with a table of campaigns, columns for clicks, cost, conversions and cost per conversion, small performance line chart on top, light minimal UI, no real brand logos, 16:9",
        },
        {
            src: "/assets/img/services/google-ads-byudjet.webp",
            alt: "Reklama byudjetining taqsimoti: qidiruv, remarketing va test kampaniyalari",
            caption: "Tipik taqsimot: 60–70% qidiruv, 15–20% remarketing, qolgani testlarga.",
            prompt:
                "Simple donut chart infographic showing advertising budget split into three segments labeled Search 65 percent, Remarketing 20 percent, Testing 15 percent, flat modern design, blue and teal palette, light background, 16:9",
        },
        {
            src: "/assets/img/services/google-ads-elon.webp",
            alt: "Google qidiruv natijasidagi reklama e'loni — sarlavha, matn va kengaytmalar",
            caption: "Bitta e'lon uchun 3–4 variant yoziladi va ular o'zaro sinovdan o'tkaziladi.",
            prompt:
                "Mockup of a Google search results page top area showing a sponsored ad block with headline, description, sitelink extensions and phone extension, generic company name, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Qidiruv natijasi va sayt tezligi — reklama sifat ko'rsatkichiga ta'sir qiluvchi omillar",
            caption: "Sekin qo'nish sahifasi sifat ko'rsatkichini tushiradi va bosish narxini oshiradi.",
        },
    ],
    related: ["seo", "google-business", "landing-page", "internet-dokonlar"],
};

const ru = {
    meta: {
        title: "Google Ads — настройка и ведение контекстной рекламы",
        description:
            "Контекстная реклама Google Ads: настройка кампаний, отслеживание конверсий, еженедельная оптимизация. Первые заявки за несколько дней. Ведение — от 4 000 000 сум в месяц.",
        keywords: [
            "Google Ads",
            "контекстная реклама",
            "настройка Google Ads",
            "стоимость Google Ads",
            "цена клика CPC",
            "рекламный бюджет",
            "ремаркетинг",
            "стоимость лида",
            "контекстная реклама Ташкент",
        ],
    },
    hero: {
        eyebrow: "Google Ads / Контекстная реклама",
        h1: "Google Ads — первая заявка уже на этой неделе",
        lead:
            "SEO требует месяцев ожидания. Google Ads даёт трафик с первого дня запуска. Мы показываем объявление тем, кто уже ищет вас, отчитываемся за каждый сум и направляем бюджет туда, где появляется результат.",
        ctaPrimary: "Получить бесплатный расчёт",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Бюджет остаётся на вашем аккаунте",
            "Стоимость каждой заявки видна в цифрах",
            "Объявления на узбекском и русском",
            "Еженедельная оптимизация, ежемесячный отчёт",
        ],
    },
    intro: {
        h: "Что такое Google Ads и как это работает",
        p: [
            "Google Ads — система, которая показывает ваше объявление в верхней части поисковой выдачи именно тогда, когда человек ищет то, что вы продаёте. Пользователь набирает «установка кондиционера в Ташкенте цена» и первой строкой видит ваше предложение. Вы не покупаете внимание — вы отвечаете на уже сформированную потребность.",
            "Деньги списываются за клик, а не за показ. В этом основная сила контекста: объявление может показаться тысячу раз, но пока по нему не кликнули, деньги не уходят. Стоимость клика определяется аукционом, где учитываются ваша ставка и показатель качества объявления. При высоком качестве объявления вы окажетесь выше конкурента даже с меньшей ставкой.",
            "На рынке Узбекистана стоимость клика сильно различается по нишам. По обычным коммерческим запросам CPC обычно держится в диапазоне 600–2 500 сум. В конкурентных направлениях — медицина, юридические услуги, недвижимость, стройматериалы — доходит до 3 000–10 000 сум. Точную цифру можно назвать только после проверки запросов вашей ниши, и этот расчёт мы делаем бесплатно.",
            "О слабой стороне тоже скажем прямо: как только реклама останавливается, останавливается и трафик. Работа, вложенная в SEO, остаётся на сайте, а в контексте поток заявок обнуляется в день окончания бюджета. Поэтому многие наши клиенты стартуют с рекламы, параллельно ведут SEO и с шестого месяца постепенно сокращают рекламный бюджет.",
            "Ещё один важный момент: реклама не спасает плохой сайт. Если посадочная страница медленно загружается, номер телефона не виден, а форма не работает на телефоне, вы платите за клики и не получаете заявок. Поэтому перед запуском кампании мы проверяем страницу и открыто говорим о найденных проблемах.",
            "Есть и ещё одна особенность местного рынка: объявления нужно писать на двух языках. По узбекоязычным запросам конкуренция чаще ниже, а значит, и клик обходится дешевле, но большинство компаний этот сегмент просто игнорирует. Мы готовим тексты на обоих языках для каждой группы объявлений и показываем в отчёте, какой язык даёт более дешёвую заявку.",
        ],
    },
    definition: {
        term: "Что такое контекстная реклама?",
        text:
            "Контекстная реклама — показ объявления, соответствующего поисковому запросу или интересам пользователя, с оплатой только за клик. Google Ads — крупнейшая платформа этого вида рекламы.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Что входит в услугу Google Ads",
        sub: "Из списка подбирается нужное вам — план формируется после расчёта.",
        items: [
            "Анализ ключевых слов и конкурентов, прогноз стоимости клика",
            "Настройка аккаунта Google Ads с нуля или аудит существующего",
            "Сборка поисковых кампаний и групп объявлений",
            "Тексты объявлений на узбекском и русском, по 3–4 варианта на группу",
            "Список минус-слов — отсечение бесполезных кликов",
            "Подключение Google Analytics 4 и отслеживания конверсий",
            "Оценка посадочной страницы и конкретные рекомендации по правкам",
            "Ремаркетинг: возврат тех, кто зашёл, но не оставил заявку",
            "Кампании Performance Max и Shopping (для интернет-магазинов)",
            "Показы в YouTube и контекстно-медийной сети (при необходимости)",
            "Еженедельная оптимизация: ставки, запросы, объявления, распределение бюджета",
            "A/B-тесты: заголовки, тексты, расширения, посадочные страницы",
            "Ежемесячный отчёт: количество заявок, стоимость заявки, динамика",
            "Настройка отслеживания звонков (call tracking)",
        ],
    },
    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что даёт Google Ads",
        sub: "Его сила в двух вещах — скорости и измеримости.",
        items: [
            {
                t: "Результат за несколько дней",
                d: "Первые визиты приходят в день запуска кампании. Это самый удобный канал, чтобы быстро проверить новый продукт или акцию.",
            },
            {
                t: "Виден каждый сум",
                d: "В таблице видно, какой запрос принёс сколько заявок и во сколько обошлась каждая. Это самый прозрачный канал в маркетинге.",
            },
            {
                t: "Показ только заинтересованным",
                d: "Объявление видит человек, который прямо сейчас ищет ваш продукт. В отличие от баннера или телевидения, здесь нет бесполезной аудитории.",
            },
            {
                t: "Бюджет под полным контролем",
                d: "Вы ограничиваете дневной расход, регионы, время показа и тип устройства. Остановить или увеличить можно в любой момент.",
            },
            {
                t: "Возврат ушедших посетителей",
                d: "К тем, кто зашёл на сайт и не оставил заявку, обращаемся снова через ремаркетинг. Обычно это самый дешёвый источник заявок.",
            },
            {
                t: "Готовые данные для SEO",
                d: "За месяц-два реклама точно показывает, какие запросы реально приносят деньги. Эти данные делают дальнейший SEO-план заметно точнее.",
            },
            {
                t: "Быстрая реакция на сезон",
                d: "В недели роста спроса бюджет увеличивается, в спад — снижается. В SEO такой оперативный манёвр невозможен.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "Для кого Google Ads эффективен",
        sub: "Для бизнесов, чей продукт ищут и чья маржа с клиента оправдывает рекламные расходы.",
        items: [
            {
                t: "Кому заявки нужны быстро",
                d: "Только что открывшийся бизнес или горящий план продаж. Ждать результатов SEO несколько месяцев нет возможности.",
            },
            {
                t: "Сезонный бизнес",
                d: "Кондиционеры, отопление, праздничные услуги. В недели пикового спроса скорость выхода в показ решает всё.",
            },
            {
                t: "Сфера услуг",
                d: "Клиники, юристы, ремонт, клининг. Ценность одного клиента высокая, поэтому реклама окупается быстро.",
            },
            {
                t: "Интернет-магазины",
                d: "Кампании Shopping и Performance Max под карточки товаров. При корректно подключённом каталоге результат стабилен.",
            },
            {
                t: "Тестирование нового продукта",
                d: "Двухнедельный рекламный тест без больших вложений точно покажет, работает ли идея на рынке.",
            },
            {
                t: "Те, кто только начал SEO",
                d: "Пока SEO набирает обороты, реклама удерживает трафик. Позже рекламный бюджет поэтапно сокращается.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость услуг Google Ads",
        sub: "Оплата услуги и рекламный бюджет — это две разные суммы. Бюджет уходит напрямую в Google.",
        note:
            "Важно: рекламный бюджет оплачивается с вашего аккаунта и к нам не поступает — вы сами видите каждый сум. Мы берём оплату только за настройку и ведение. Комиссия агентства на рынке обычно составляет 10–20% от бюджета; у нас это 15% либо фиксированная сумма ниже — что больше. Минимальный рекомендуемый рекламный бюджет — 8 000 000 сум в месяц: при меньшем данные не накапливаются, и оптимизировать нечего. Вопросы: +998 90 954 12 62.",
        tiers: [
            {
                name: "Запуск",
                tagline: "Разовая настройка",
                price: "4 500 000 сум",
                priceNote: "разово",
                term: "7–10 рабочих дней",
                best: "Тем, кто хочет получить правильно собранный аккаунт и вести его силами своего маркетолога",
                features: [
                    "Анализ ключевых слов и конкурентов, прогноз CPC",
                    "Сборка аккаунта Google Ads с нуля",
                    "2–3 поисковые кампании и группы объявлений",
                    "Тексты объявлений на узбекском и русском",
                    "Базовый список минус-слов",
                    "Подключение GA4 и отслеживания конверсий",
                    "Список рекомендаций по посадочной странице",
                    "Двухчасовое обучение работе с аккаунтом",
                ],
            },
            {
                name: "Ведение",
                tagline: "Постоянная работа и оптимизация",
                price: "4 000 000 сум",
                priceNote: "в месяц или 15% от бюджета — что больше",
                term: "Абонентская плата",
                best: "Тем, кому нужен стабильный и прогнозируемый поток заявок с рекламы",
                featured: true,
                features: [
                    "Все работы пакета «Запуск» в первый месяц",
                    "Еженедельная оптимизация: ставки, запросы, объявления",
                    "Отключение неэффективных запросов и перераспределение бюджета",
                    "Ремаркетинговые кампании",
                    "Регулярное обновление объявлений и расширений",
                    "A/B-тесты: заголовки, тексты, посадочные страницы",
                    "Настройка отслеживания звонков",
                    "Ежемесячный отчёт: количество, стоимость и динамика заявок",
                    "Ежемесячная встреча по результатам",
                ],
            },
            {
                name: "Комплекс",
                tagline: "Реклама + посадочные + аналитика",
                price: "8 000 000 сум",
                priceNote: "в месяц или 12% от бюджета — что больше",
                term: "Абонентская плата",
                best: "Тем, у кого большой бюджет, несколько направлений или широкий каталог",
                features: [
                    "Все работы пакета «Ведение»",
                    "Отдельные посадочные страницы под кампании",
                    "Кампании Shopping и Performance Max",
                    "Связка с CRM: превратилась ли заявка в сделку",
                    "Глубокая аналитика: какой канал приводит каких клиентов",
                    "Несколько регионов, языков и продуктовых направлений",
                    "Кампании в YouTube и контекстно-медийной сети",
                    "Персональный менеджер и связь раз в неделю",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как запускается реклама",
        sub: "Первые заявки обычно приходят в течение 3–10 дней после запуска.",
        steps: [
            {
                t: "Анализ и расчёт",
                time: "2–4 дня",
                d: "Разбираем нишу, конкурентов и запросы. Считаем ориентировочную стоимость клика, ожидаемое количество заявок и нужный бюджет — бесплатно.",
            },
            {
                t: "Настройка отслеживания",
                time: "2–3 дня",
                d: "Подключаем GA4, цели по конверсиям и отслеживание звонков. Без этого реклама работает вслепую: непонятно, какой запрос приносит деньги.",
            },
            {
                t: "Сборка кампаний",
                time: "3–7 дней",
                d: "Группируем ключевые слова, пишем тексты объявлений на двух языках, добавляем минус-слова, настраиваем регионы и расписание показов.",
            },
            {
                t: "Распределение бюджета",
                time: "1 день",
                d: "Стандартная схема: 60–70% на горячие коммерческие запросы, 15–20% на ремаркетинг, 10–20% на проверку новых гипотез.",
            },
            {
                t: "Запуск",
                time: "1 день",
                d: "Кампании включаются. Первую неделю контроль плотнее — лишние запросы отсекаются при ежедневной проверке поисковых фраз.",
            },
            {
                t: "Оптимизация",
                time: "еженедельно",
                d: "Смотрим, какой запрос дал заявку, а какой только потратил бюджет. На этом основании меняем ставки и переносим деньги туда, где есть отдача.",
            },
            {
                t: "Отчёт и план",
                time: "ежемесячно",
                d: "Показываем количество заявок, стоимость одной заявки и долю сделок. План на следующий месяц строится на этих цифрах.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Сайты, подготовленные под рекламный трафик",
        sub: "Эти проекты разрабатывались с учётом конверсии и потока с платных каналов.",
        cta: "Смотреть все проекты",
        slugs: ["mountain-and-sea", "cleanza", "global-building-group", "ipsum-pathology"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы про Google Ads",
        sub: "Открытые ответы про бюджет, стоимость и результат.",
        items: [
            {
                q: "Сколько стоит настройка и ведение Google Ads?",
                a: "В Innobek разовая настройка стоит 4 500 000 сум. Постоянное ведение — 4 000 000 сум в месяц или 15% от рекламного бюджета, что больше. Комплексный пакет — 8 000 000 сум или 12% от бюджета. Все суммы не включают рекламный бюджет: он оплачивается напрямую в Google с вашего аккаунта.",
            },
            {
                q: "Какой рекламный бюджет нужен?",
                a: "Минимальная рекомендация — 8 000 000 сум в месяц. При меньшей сумме алгоритм не накапливает достаточно данных для обучения, и оптимизация теряет смысл. В конкурентных нишах стартовый бюджет начинается с 15–25 миллионов сум. Точная цифра считается по CPC вашей ниши и нужному количеству заявок.",
            },
            {
                q: "Как распределяется рекламный бюджет?",
                a: "Стандартная схема: 60–70% уходит на горячие коммерческие запросы («цена», «купить», «заказать»), 15–20% на ремаркетинг, оставшиеся 10–20% на проверку новых запросов и гипотез. В первый месяц доля тестов выше, а затем бюджет перераспределяется в пользу кампаний, которые дают заявки. В ежемесячном отчёте отдельно показывается, как и почему изменилось распределение.",
            },
            {
                q: "Сколько составляет комиссия агентства?",
                a: "На рынке Узбекистана агентства обычно берут 10–20% от рекламного бюджета. В Innobek комиссия составляет 15% либо фиксированные 4 000 000 сум — что больше. Для крупных бюджетов в комплексном пакете процент снижается до 12. Скрытых доплат нет, наценка на бюджет не добавляется.",
            },
            {
                q: "Сколько стоит клик в Узбекистане?",
                a: "По обычным коммерческим запросам CPC держится в диапазоне 600–2 500 сум. В конкурентных нишах — медицина, юридические услуги, недвижимость, строительство — доходит до 3 000–10 000 сум. Точная цифра зависит от аукциона, ставок конкурентов и показателя качества объявления. В расчёте мы даём реальный диапазон по вашей нише.",
            },
            {
                q: "Во сколько обходится одна заявка?",
                a: "Это зависит от стоимости клика и конверсии страницы. Например, при клике 1 500 сум и конверсии 4% одна заявка обойдётся примерно в 37 500 сум. Рост конверсии до 6% снижает стоимость заявки до 25 000 сум — поэтому мы всегда работаем и с посадочной страницей.",
            },
            {
                q: "Через сколько виден результат?",
                a: "Первые визиты приходят в день включения кампании, первые заявки — обычно в течение 3–10 дней. Но первые 2–4 недели — это период обучения: алгоритм накапливает данные, а мы отсекаем лишние запросы и корректируем ставки. Стабильный и прогнозируемый результат формируется начиная со второго месяца. Не оценивайте цифры первого месяца как окончательные.",
            },
            {
                q: "Рекламный бюджет переходит к вам?",
                a: "Нет. Аккаунт открывается на ваше имя, карта тоже ваша. Google списывает деньги напрямую с вас, мы получаем только права на управление. Благодаря этому вы в любой момент можете проверить, куда ушёл каждый сум. При завершении договора аккаунт полностью остаётся у вас.",
            },
            {
                q: "У меня нет сайта, только Instagram — подойдёт?",
                a: "Для Google Ads нужна посадочная страница. Вести рекламу на профиль Instagram технически можно, но конверсия будет заметно ниже, а отслеживание работает не полностью. Самое доступное решение — собрать один лендинг. Мы делаем это отдельной услугой и запускаем вместе с рекламой.",
            },
            {
                q: "Могу ли я вести рекламу сам?",
                a: "Да, можете. В пакете «Запуск» мы собираем аккаунт правильно и обучаем вашу команду. Но учитывайте: интерфейс Google постоянно предлагает автоматические кампании, и в неопытных руках бюджет расходуется быстро. Логичнее отдать ведение нам на первые 2–3 месяца, а затем перенять его.",
            },
            {
                q: "Нужно ли вести SEO и Google Ads одновременно?",
                a: "Если бюджет позволяет — да, это самая эффективная связка. Реклама даёт заявки уже сегодня и быстро показывает, какие запросы реально приносят деньги. SEO строится на этих данных точнее и с шестого месяца снижает стоимость заявки. Со временем рекламный бюджет можно сокращать.",
            },
        ],
    },
    cta: {
        h: "Хотите узнать, во сколько обойдётся реклама в вашей нише?",
        p: "На бесплатном расчёте покажем объём запросов, ориентировочную стоимость клика и необходимый бюджет. Если цифры вам не подходят — скажем об этом прямо.",
        button: "Получить бесплатный расчёт",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/services/google-ads-kampaniya.webp",
            alt: "Панель кампаний Google Ads: клики, конверсии и стоимость заявки",
            caption: "В панели управления видно количество и стоимость заявок по каждой кампании.",
            prompt:
                "Clean Google Ads style campaign dashboard with a table of campaigns, columns for clicks, cost, conversions and cost per conversion, small performance line chart on top, light minimal UI, no real brand logos, 16:9",
        },
        {
            src: "/assets/img/services/google-ads-byudjet.webp",
            alt: "Распределение рекламного бюджета: поиск, ремаркетинг и тестовые кампании",
            caption: "Типичное распределение: 60–70% поиск, 15–20% ремаркетинг, остальное на тесты.",
            prompt:
                "Simple donut chart infographic showing advertising budget split into three segments labeled Search 65 percent, Remarketing 20 percent, Testing 15 percent, flat modern design, blue and teal palette, light background, 16:9",
        },
        {
            src: "/assets/img/services/google-ads-elon.webp",
            alt: "Рекламное объявление в результатах поиска Google — заголовок, текст и расширения",
            caption: "Для одного объявления пишется 3–4 варианта, которые тестируются между собой.",
            prompt:
                "Mockup of a Google search results page top area showing a sponsored ad block with headline, description, sitelink extensions and phone extension, generic company name, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Выдача поиска и скорость сайта — факторы, влияющие на показатель качества рекламы",
            caption: "Медленная посадочная снижает показатель качества и повышает цену клика.",
        },
    ],
    related: ["seo", "google-business", "landing-page", "internet-dokonlar"],
};

const content = { uz, ru };

export default content;
